import api from "./api";

let configPromise = null;

/** Clave para Maps JavaScript API: VITE en build o proxy autenticado en servidor. */
export async function fetchGoogleMapsApiKey() {
  const vite = (import.meta.env.VITE_GOOGLE_PLACES_API_KEY || "").trim();
  if (vite) return vite;
  if (!configPromise) {
    configPromise = api
      .get("/geo/maps-config")
      .then((r) => {
        const key = (r.data?.apiKey || "").trim();
        if (!r.data?.ok || !key) throw new Error("missing_maps_key");
        return key;
      })
      .catch((err) => {
        configPromise = null;
        throw err;
      });
  }
  return configPromise;
}
